import { t } from '@lingui/macro';

const getTranslations = ({ i18n }) => ({
  ACCURACY_BUTTON_TEXT: i18n._(t('AccuracyProgressToggle.Accuracy')`Accuracy`),
  PROGRESS_BUTTON_TEXT: i18n._(t('AccuracyProgressToggle.Progress')`Progress`),
  ACCURACY_BUTTON_TITLE: i18n._(
    t('AccuracyProgressToggle.Accuracy.HoverTitle')`View student attempts by the average accuracy of their answers`
  ),
  PROGRESS_BUTTON_TITLE: i18n._(
    t('AccuracyProgressToggle.Progress.HoverTitle')`View student attempts by the progress made`
  ),
  ACCURACY_INFO_TEXT: i18n._(
    t(
      'AccuracyProgressToggle.Accuracy.Info'
    )`Accuracy is calculated by total correct responses divided by attempts and multiplied by 100`
  ),
  PROGRESS_INFO_TEXT: i18n._(
    t(
      'AccuracyProgressToggle.Progress.Info'
    )`Progress shows the ratio of complete vs incomplete steps for each Skill Quest`
  )
});

export default getTranslations;
